import { FormEvent, useContext, useState } from 'react';

import IconButton from '../../../../../components/atoms/button/IconButton';
import Input from '../../../../../components/atoms/input';
import TextArea from '../../../../../components/atoms/text-area/TextArea';
import { TextSurveyContentData, TextSurveyContentSpecificData } from '../../../../../types/contentTypes';
import AlertContext from '../../../../../utils/AlertContext';
import { ContentFormProps } from '../../ContentEditor';
import inputFields from '../../inputFields.json';

export default function TextSurveyContentForm({
  content,
  onNewContentSubmit,
  onExistingContentSubmit,
}: ContentFormProps<TextSurveyContentData, TextSurveyContentSpecificData>) {
  const [headline, setHeadline] = useState<string>(content?.headline || '');
  const [description, setDescription] = useState<string>(content?.description || '');

  const showAlert = useContext(AlertContext);

  function handleSubmit(e: FormEvent) {
    e.preventDefault();
    if (!content) {
      onNewContentSubmit?.({
        headline,
        description,
      });
    } else {
      onExistingContentSubmit?.({
        ...content,
        headline,
        description,
      });
    }
    showAlert('Changes saved!');
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="self-start">
        <label className="block mb-2">Enter headline</label>
        <Input className="mb-8 w-full" {...inputFields.headline} state={[headline, setHeadline]} />
      </div>
      <label className="block mb-4 font-medium">Survey description</label>
      <TextArea
        className={`w-full mb-12`}
        state={[description, setDescription]}
        placeholder="Enter a description of the video"
        required
        rows={4}
      />
      <IconButton icon="save-outline" label={!content ? 'Save and add to section' : 'Save changes'} type="submit" />
    </form>
  );
}
